module.exports = {
	"library.navbar.sign_up": "Opret dig",
	"library.navbar.sign_in": "Log ind",
	"library.navbar.sign_out": "Log ud",
	"library.navbar.help": "Hjælp",
	"library.navbar.search_for_events": "Søg efter begivenheder",
	"library.navbar.enter_location": "Indtast placering",
	"library.navbar.find_events": "Find begivenheder",
	"library.navbar.create_event": "Opret begivenhed",
	"library.navbar.host_events": "Afhold begivenhed",
	"library.navbar.dashboard": "Instrumentbræt",
	"library.navbar.my_events": "Mine arrangementer",
	"library.navbar.my_tickets": "Mine billetter",
	"library.navbar.admin_panel": "Administratorpanel",
	"library.navbar.profile": "Profil",
	"library.navbar.messages": "Beskeder",
	"library.navbar.settings": "Indstillinger",
	"library.navbar.search_cities": "Søg i byer",
	"library.navbar.help_center": "Hjælp-center",
	"library.navbar.cant_find_tickets": "Hvor er mine billetter?",
	"library.navbar.contact_organizer": "Kontakt arrangøren for arrangementet",
	"library.navbar.can_refund": "Kan jeg få mine penge retur?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/da.json
// module id = 1507
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16